import React from 'react';
import Header from '../../components/header/header';
import { Link } from 'react-router-dom';
import './new.scss';
import { motion } from "motion/react";

const New = () => {
  return (
    <div className="new">
      <Header />

      {/* Hero Section */}
      <section className="hero6">
        <div className="hero-content6">
          <h1>Welcome Home</h1>
          <p>We're so glad you're here! Whether you're exploring faith for the first time or looking for a church home, you belong here.</p>
          <Link to="/visit" className="hero-button6">Plan Your Visit</Link>
        </div>
      </section>

      {/* What We Believe Section - Scale + Fade */}
      <motion.section
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="section6"
      >
        <div className="section-header6">
          <h2 className="section-title6">What We Believe</h2>
          <p className="section-subtitle6">Our core beliefs are rooted in the Bible and centered on Jesus Christ</p>
        </div>

        <div className="beliefs-grid">
          {[
            { icon: "📖", title: "The Bible", desc: "We believe the Bible is God's inspired Word and the ultimate authority for faith and life." },
            { icon: "✝️", title: "Jesus Christ", desc: "We believe Jesus is the Son of God who died for our sins and rose again, offering salvation to all." },
            { icon: "🕊️", title: "The Holy Spirit", desc: "We believe the Holy Spirit empowers believers to live godly lives and bear fruit for God's kingdom." },
            { icon: "🙏", title: "Grace", desc: "We believe salvation is a free gift from God received through faith, not earned by our works." },
            { icon: "⛪", title: "The Church", desc: "We believe the church is God's family, united in purpose to worship, grow, and serve together." },
            { icon: "🌍", title: "Mission", desc: "We believe we are called to share the Gospel and make disciples of all nations through love and service." }
          ].map((belief, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="belief-card"
            >
              <div className="belief-icon">{belief.icon}</div>
              <h3>{belief.title}</h3>
              <p>{belief.desc}</p>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* Next Steps Section - Slide from left */}
      <motion.section
        initial={{ opacity: 0, x: -60 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.8 }}
        className="section6 add-n"
      >
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div className="section-header6">
            <h2 className="section-title6 new-c">Your Next Steps</h2>
            <p className="section-subtitle6">Getting connected is easy! Here's how to get started with us.</p>
          </div>

          <div className="steps-grid">
            {[
              { num: 1, title: "Attend a Service", desc: "Join us for worship any Sunday at 9:00 AM. Come as you are and experience our welcoming community.", link: "/visit", linkText: "Plan Your Visit" },
              { num: 2, title: "Connect with Us", desc: "Have a question, prayer request, or want to learn more? Send us a message, connect with us on social media, or worship with us through our online services.", link: "/connect", linkText: "Get Connected" },
              { num: 3, title: "Join a Small Group", desc: "Build meaningful relationships and grow in your faith by joining one of our small groups that meet throughout the week.", link: "/departments", linkText: "Find a Department" },
              // { num: 4, title: "Discover Your Purpose", desc: "Explore opportunities to serve using your unique gifts and talents. Making a difference starts here!", link: "/departments", linkText: "Get Involved" }
            ].map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                className="step-card"
              >
                <div className="step-number">{step.num}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
                <Link to={step.link} className="step-link">{step.linkText}</Link>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      {/* FAQ Section - Blur to focus with stagger */}
      <motion.section
        initial={{ opacity: 0, filter: "blur(8px)" }}
        whileInView={{ opacity: 1, filter: "blur(0px)" }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.9 }}
        className="section6"
      >
        <div className="section-header6">
          <h2 className="section-title6">Frequently Asked Questions</h2>
        </div>

        <div className="faq-container">
          {[
            { q: "What should I wear?", a: "Come as you are! You'll see everything from jeans and t-shirts to business casual. We care about your heart, not your outfit." },
            { q: "Where do I park?", a: "Free parking is available in our main lot and across the street. Our hospitality team can help direct you to available spots." },
            { q: "What about my kids?", a: "We have safe, engaging programs for children from infants through 5th grade during both services. Check-in starts 15 minutes before service." },
            { q: "How long is the service?", a: "Services are typically 90 minutes, including 25 minutes of worship and a 40-minute message with prayer and communion." },
            { q: "Do I have to give money?", a: "Absolutely not! You give as you are led by the Holy Spirit." },
            { q: "Can I get baptized?", a: "Yes! We celebrate baptisms regularly. If you've decided to follow Jesus, we'd love to talk with you about taking this important step." }
          ].map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="faq-item"
            >
              <h4>{faq.q}</h4>
              <p>{faq.a}</p>
            </motion.div>
          ))}
        </div>
      </motion.section>
    </div>
  );
};

export default New;
